const dict = {
  "这篇文章仅订阅者/会员可见": {
    zh: "这篇文章仅订阅者/会员可见",
    en: "This post is for subscribers only",
  },
  这篇文章仅供翻山会员阅览: {
    zh: "这篇文章仅供翻山会员阅览",
    en: "This post is for paying subscribers only",
  },
  "这篇文章仅供 {tiers} 的会员阅览": {
    zh: "这篇文章仅供 {tiers} 的会员阅览",
    en: "This post is for subscribers on the {tiers} only",
  },
  评论区: {
    zh: "评论区",
    en: "Member discussion",
  },
  "你可能也感兴趣...": {
    zh: "你可能也感兴趣...",
    en: "You might also like...",
  },
  登录: {
    zh: "登录",
    en: "Login",
  },
  升级你的会员: {
    zh: "升级你的会员",
    en: "Upgrade now",
  },
  成为会员: {
    zh: "成为会员",
    en: "Subscribe now",
  },
  "已经是翻山的会员了？点击这里登录": {
    zh: "已经是翻山的会员了？点击这里登录",
    en: "Already have an account? Sign in",
  },
  账号: {
    zh: "账号",
    en: "Account",
  },
  "近日通讯 ": {
    zh: "近日通讯 ",
    en: "Newer Posts ",
  },
  "往日通讯 ": {
    zh: "往日通讯 ",
    en: "Older Posts ",
  },
  // not translated by jquery.translate.js
  fanshanDescription: {
    zh: "「翻山」由一群来自不同界别的姐妹联合出品<br />\n" +
      "        以内容为桥梁，架设性别平等在中国大陆的参与渠道<br />\n" +
      "        「翻山」将主要收入投资至中国大陆的性别团队<br />\n" +
      "        <span class='underline-text-in-cover'>每一份订阅，都将汇入性别平等的川流</span>",
    en: "fanshan is dedicated to forging public participation in the cause of gender equality in mainland China through our newsletter. Our team is a coalition of individuals with feminist-queer identities and diverse backgrounds. As a non-profit venture, a considerable portion of fanshan's income is re-invested into gender equality and women’s empowerment organizations in China. Together, we march towards China's future of gender equality that is built of us, by us, and for us.",
  },
  termsOfService: {
    zh: "服务条例",
    en: "terms of service",
  }
};

// 从localStorage中获取存储的语言配置
let localCustomSiteConfig = localStorage.getItem("customSiteConfig");
let localCustomSiteConfigObj = !localCustomSiteConfig
  ? {}
  : JSON.parse(localCustomSiteConfig);

// 导航栏每一项与双语链接的对应关系存储在Code Injection的navigationMap变量中
// 如果Code Injection中的navigationMap不存在，则默认为空对象
if (!window.navigationMap) window.navigationMap = {};

// 编译模板, enPostListSource和zhPostListSource在default.hbs中定义
let enPostTemplate = Handlebars.compile(window.enPostListSource);
let zhPostTemplate = Handlebars.compile(window.zhPostListSource);
// 获取首页推荐阅读post列表的html
let enPostsHtml = enPostTemplate();
let zhPostsHtml = zhPostTemplate();

// 如果localStorage中语言配置不存在，则设为中文
if (!localCustomSiteConfig) {
  localCustomSiteConfigObj = {
    locale: "zh",
  };
} else {
  // 如果语言配置已存在，则根据语言配置修改当前URL的pathname
  changePathnameByLocale();

  if (localCustomSiteConfigObj.locale === "en") {
    handleMainpageElementsInEn();
  }

  $("body").translate({
    lang: localCustomSiteConfigObj.locale === "zh" ? "zh" : "en",
    t: dict,
  });
  translateCommonTexts();
}

// 根据语言配置，修改导航栏的标签和链接
translateNavBar(localCustomSiteConfigObj, window.navigationMap);

// 根据语言配置，渲染首页对应语言的Post列表
if (document.getElementById("postContainer")) {
  appendPostListInMainpage(localCustomSiteConfigObj.locale);
}

document.addEventListener("DOMContentLoaded", function () {
  // 实时修改语言转换按钮的checked
  const checkbox = document.getElementById("langSwitchCheckbox");
  checkbox.checked = localCustomSiteConfigObj.locale === "en";

  if (localCustomSiteConfigObj.locale === "en") {
    translateAnnouncementBarText()
  }
});

function handleMainpageElementsInEn() {
  const subscribeBtnInHeader = document.querySelectorAll(
    "#gh-head .gh-head-inner .gh-head-actions .gh-head-members .gh-head-btn",
  )[0];
  if (subscribeBtnInHeader) {
    subscribeBtnInHeader.style.display = "none";
  }
  const subscribeBtnInCover = document.getElementById("subscribeBtnInCover");
  if (subscribeBtnInCover) {
    subscribeBtnInCover.style.display = "none";
  }
  const recommendedReading = document.getElementById("recommendedReading");
  if (recommendedReading) {
    recommendedReading.style.display = "none";
  }
  const termsOfServiceEl = document.getElementById("termsOfService");
  if (termsOfServiceEl) {
    termsOfServiceEl.innerText = dict.termsOfService.en || "terms of service";
    termsOfServiceEl.href =
      window.termsOfServicePageURL ||
      window.termsOfServicePageURL ||
      "termsofservice-en";
  }
}

function changePathnameByLocale() {
  let currentLocale = localCustomSiteConfigObj.locale;
  let pathname = window.location.pathname;
  let newPathname = pathname;
  if (pathname !== "/") {
    if (currentLocale === "zh" && pathname.endsWith("-en/")) {
      newPathname = pathname.slice(0, -4);
    } else if (currentLocale === "en" && !pathname.endsWith("-en/")) {
      newPathname = pathname.slice(0, -1) + "-en/";
    }
    if (newPathname !== pathname) {
      window.location.replace(window.location.origin + newPathname);
    }
  }
}

function appendPostListInMainpage(newLocale) {
  document.getElementById("postContainer").innerHTML =
    newLocale === "zh" ? zhPostsHtml : enPostsHtml;
}

function switchLocale(newLocale) {
  if (localCustomSiteConfigObj.locale === newLocale) {
    return;
  }
  localCustomSiteConfigObj.locale = newLocale;
  localStorage.setItem(
    "customSiteConfig",
    JSON.stringify(localCustomSiteConfigObj),
  );
  translateNavBar(localCustomSiteConfigObj, navigationMap);
  if (window.location.pathname === "/") {
    appendPostListInMainpage(newLocale);
  }
  if (window.location.pathname !== "/") {
    changePathnameByLocale();
  }

  window.location.reload();
}

window.switchLocale = switchLocale;

function buildReversedNavigationMap(navigationMap) {
  const navigationMapReverse = {};
  for (let site in navigationMap) {
    for (let lang in navigationMap[site])
      if (["zh", "en"].includes(lang)) {
        navigationMapReverse[navigationMap[site][lang]] = navigationMap[site];
      }
  }
  return navigationMapReverse;
}

function translateNavBar(localCustomSiteConfig, navigationMap) {
  const navigationMapReverse = buildReversedNavigationMap(navigationMap);
  const navElement = document.querySelector(".gh-head-menu");
  const anchorElements = navElement.querySelectorAll("a");

  anchorElements.forEach(function (anchorElement) {
    const currentHref = anchorElement.getAttribute("href"); // 获取当前的 href 属性值
    const url = new URL(currentHref);
    const currentPathname = url.pathname;
    if (!navigationMapReverse[currentPathname]) return;
    if (localCustomSiteConfig.locale === "en") {
      url.pathname = navigationMapReverse[currentPathname].en;
      anchorElement.innerText = navigationMapReverse[currentPathname].enText;
    } else {
      url.pathname = navigationMapReverse[currentPathname].zh;
      anchorElement.innerText = navigationMapReverse[currentPathname].zhText;
    }
    anchorElement.setAttribute("href", url.toString());
  });
}

function translateAnnouncementBarText() {
  const announcementRootEl = document.getElementById("announcement-bar-root");
  if (announcementRootEl) {
    const observer = new MutationObserver(function (mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
          announcementRootEl.querySelectorAll(
            ".gh-announcement-bar-content p span",
          )[0].innerText =
            window.announcementBarEnglishText ||
            "fanshan regularly publishes content of public interest in both English and Mandarin, but its subscription-based newsletter is primarily facing Chinese readers. Thus there is no subscription entrance on the English versions of the website.";
          observer.disconnect();
        }
      }
    });
    observer.observe(announcementRootEl, {childList: true});
  }
}

function translateCommonTexts() {
  $(".cover-description").html(
    localCustomSiteConfigObj.locale === "zh"
      ? dict.fanshanDescription.zh
      : dict.fanshanDescription.en,
  );
  $(".cover-description").css(
    "font-family",
    localCustomSiteConfigObj.locale === "zh"
      ? "var(--font-sans)"
      : "var(--font-urbanist)",
  );
  $("#termsOfService").text(
    localCustomSiteConfigObj.locale === "zh"
      ? dict.termsOfService.zh
      : dict.termsOfService.en,
  )
}
